var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52.63 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.63,41.32h9.21a2.64,2.64,0,0,0,2.63-2.64v-15a2.64,2.64,0,0,0-2.63-2.63H2.63A2.64,2.64,0,0,0,0,23.68v15A2.64,2.64,0,0,0,2.63,41.32Zm2.63-15h4v9.73h-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.71,41.32h9.21a2.64,2.64,0,0,0,2.63-2.64V13.16a2.63,2.63,0,0,0-2.63-2.63H21.71a2.63,2.63,0,0,0-2.63,2.63V38.68A2.64,2.64,0,0,0,21.71,41.32Zm2.63-25.53h3.95V36.05H24.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,0H40.79a2.63,2.63,0,0,0-2.63,2.63V38.68a2.64,2.64,0,0,0,2.63,2.64H50a2.64,2.64,0,0,0,2.63-2.64v-36A2.63,2.63,0,0,0,50,0ZM47.37,36.05H43.42V5.26h3.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,44.74H2.63a2.63,2.63,0,0,0,0,5.26H50a2.63,2.63,0,1,0,0-5.26Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/Insights.881590d8.svg";
export { ForwardRef as ReactComponent };